export const colors = {
  pending: '#fb8c00',
  finished: '#2e7d32',
  danger:   '#c62828',
  border:   '#e6eaf0',
  bgCard:   '#ffffff',
  label:    '#6b7280',
};

export const rowCard = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  border: `1px solid ${colors.border}`,
  background: colors.bgCard,
  borderRadius: 12,
  padding: '10px 14px',
  marginBottom: 10,
  boxShadow: '0 1px 2px rgba(0,0,0,.04)',
};

export const rowLeft = {
  flex: '1 1 auto',
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
};

export const groupTitle = {
  fontSize: 12,
  lineHeight: '14px',
  fontWeight: 600,
  color: '#464e5f',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const rowRight = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 18,
  flex: '0 1 auto',
  minWidth: 0,
  overflowX: 'auto',
  paddingBottom: 2,
};

export const metric = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minWidth: 56,
  flex: '0 0 auto',
};

export const metricValue = {
  fontSize: 16,
  fontWeight: 700,
  lineHeight: 1,
  color: '#111827',
  whiteSpace: 'nowrap',
};

export const metricLabel = {
  marginTop: 2,
  fontSize: 10,
  lineHeight: 1,
  color: colors.label,
  whiteSpace: 'nowrap',
};
